var React = require('react');

function MapMarkerAlt (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.767 31.354C1.686 18.189 0 16.838 0 12 0 5.373 5.373 0 12 0s12 5.373 12 12c0 4.838-1.686 6.189-10.767 19.354a1.501 1.501 0 0 1-2.467 0zM12 17a5 5 0 1 0-.001-10.001A5 5 0 0 0 12 17z"}));
}

MapMarkerAlt.defaultProps = {"viewBox":"0 0 24 32"};

module.exports = MapMarkerAlt;

MapMarkerAlt.default = MapMarkerAlt;
